// ============ CONFIGURATION ============
// Replace these with your real values when wiring up.
const CONFIG = {
  // Google Apps Script Web App URL (deploy from Apps Script with "Anyone" access).
  // See SETUP.md for the script code and deployment steps.
  // If left blank, files will not be uploaded — file names will be included in the email instead.
  driveUploadUrl: 'https://script.google.com/macros/s/AKfycbxDjSOoYUWRo1B3vDnGUL1fLYMfwQ54Vbdt3Xm4hiLiP3dtCu84OHWGPXCOLBAg4iclew/exec',

  // Shopify contact form: leave the action below as-is for relative posting on shop.tkojerseyco.com.
  // The form posts to /contact and lands in whatever email is set under
  // Shopify Admin → Settings → Notifications → Customer contact (or "Contact form").
  shopifyContactPath: '/contact#contact_form',

  // Maximum total upload size (per file). Drive can handle big files, but Apps Script
  // has a 50MB request limit. Keep individual files under ~40MB.
  maxFileSizeMB: 40,
};

// ============ STATE ============
const state = {
  current: 1,
  totalSteps: 4,
  selectedSports: new Set(),
  selectedItems: new Set(),
  data: {}
};

// ============ STEP NAV ============
function setActiveStep(n) {
  document.querySelectorAll('.step-card').forEach(c => c.classList.remove('active'));
  const card = document.querySelector(`.step-card[data-step="${n}"]`);
  if (card) {
    card.classList.add('active');
    card.classList.remove('complete');
    card.scrollIntoViewIfNeeded ? card.scrollIntoViewIfNeeded() : card.scrollIntoView({behavior:'smooth', block:'start'});
  }
  // progress rail
  document.querySelectorAll('.progress-step').forEach(s => {
    s.classList.remove('active');
    const goto = parseInt(s.dataset.go);
    if (goto === n) s.classList.add('active');
  });
  state.current = n;
  updateProgressBar();
}

function toggleStep(n) {
  const card = document.querySelector(`.step-card[data-step="${n}"]`);
  if (!card) return;
  if (card.classList.contains('active')) return; // already open
  setActiveStep(n);
}

function goBack(from) {
  setActiveStep(from - 1);
}

function markComplete(n, summaryHTML) {
  const card = document.querySelector(`.step-card[data-step="${n}"]`);
  if (!card) return;
  card.classList.add('complete');
  card.classList.remove('active');
  document.getElementById(`summary${n}`).innerHTML = summaryHTML;
  // progress rail tick
  const rail = document.querySelector(`.progress-step[data-go="${n}"]`);
  if (rail) rail.classList.add('complete');
}

function completeStep(n) {
  // basic validation per step
  if (n === 1) {
    const teamName = document.getElementById('teamName').value.trim();
    const sport = state.selectedSports.size;
    const orderType = document.querySelector('input[name="orderType"]:checked');
    if (!teamName || !sport || !orderType) { flashIncomplete(); return; }
    const sports = [...state.selectedSports].join(', ');
    const otherText = document.getElementById('sportOtherText').value.trim();
    const sportLabel = state.selectedSports.has('Other') && otherText ? sports + ' (' + otherText + ')' : sports;
    markComplete(1, `<strong>${esc(teamName)}</strong> · <span class="summary-chip">${esc(sportLabel)}</span> · <span class="summary-chip">${esc(orderType.value === 'new' ? 'New design' : orderType.value === 'reorder' ? 'Reorder' : 'Not sure')}</span>`);
    setActiveStep(2);
  } else if (n === 2) {
    const items = state.selectedItems.size;
    const qty = document.querySelector('input[name="qty"]:checked');
    const date = document.getElementById('deadline').value;
    const flex = document.getElementById('flexible').checked;
    if (!items || !qty || (!date && !flex)) { flashIncomplete(); return; }
    const itemList = [...state.selectedItems].slice(0, 4).map(i => `<span class="summary-chip">${esc(i)}</span>`).join('');
    const more = state.selectedItems.size > 4 ? ` <span class="summary-chip">+${state.selectedItems.size - 4} more</span>` : '';
    const dateLabel = flex ? 'Flexible' : new Date(date).toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'});
    markComplete(2, `${itemList}${more} · <span class="summary-chip">${esc(qty.value)} pcs</span> · <span class="summary-chip">${esc(dateLabel)}</span>`);
    setActiveStep(3);
  } else if (n === 3) {
    const v = document.getElementById('vision').value.trim();
    if (!v) { flashIncomplete(); return; }
    const logoCount = document.getElementById('logoFiles').files.length;
    const inspoCount = document.getElementById('inspoFiles').files.length;
    const visionShort = v.length > 60 ? v.slice(0, 60) + '…' : v;
    let bits = `<strong>"${esc(visionShort)}"</strong>`;
    if (logoCount) bits += ` · <span class="summary-chip">📎 ${logoCount} logo${logoCount > 1 ? 's' : ''}</span>`;
    if (inspoCount) bits += ` · <span class="summary-chip">📎 ${inspoCount} inspo</span>`;
    markComplete(3, bits);
    setActiveStep(4);
  }
}

function updateProgressBar() {
  const completed = document.querySelectorAll('.step-card.complete').length;
  const pct = Math.min(100, (completed / state.totalSteps) * 100 + (state.current === state.totalSteps && completed === state.totalSteps - 1 ? 0 : 0));
  document.getElementById('progressFill').style.width = (completed * 25) + '%';
}

function flashIncomplete() {
  const card = document.querySelector('.step-card.active');
  if (!card) return;
  card.style.animation = 'shake 0.4s';
  setTimeout(() => card.style.animation = '', 500);
}

// shake keyframes added inline
const style = document.createElement('style');
style.textContent = `@keyframes shake { 10%, 90% { transform: translateX(-2px); } 20%, 80% { transform: translateX(4px); } 30%, 50%, 70% { transform: translateX(-6px); } 40%, 60% { transform: translateX(6px); } }`;
document.head.appendChild(style);

function esc(s) { return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

// ============ SPORT GRID ============
document.querySelectorAll('#sportGrid .sport-card').forEach(card => {
  card.addEventListener('click', () => {
    const sport = card.dataset.sport;
    if (state.selectedSports.has(sport)) {
      state.selectedSports.delete(sport);
      card.classList.remove('selected');
    } else {
      state.selectedSports.add(sport);
      card.classList.add('selected');
    }
    document.getElementById('sportOtherWrap').style.display =
      state.selectedSports.has('Other') ? 'block' : 'none';
  });
});

// ============ ITEM CARDS ============
document.querySelectorAll('.item-card').forEach(card => {
  card.addEventListener('click', () => {
    const item = card.dataset.item;
    if (state.selectedItems.has(item)) {
      state.selectedItems.delete(item);
      card.classList.remove('selected');
    } else {
      state.selectedItems.add(item);
      card.classList.add('selected');
    }
    const c = state.selectedItems.size;
    const target = document.getElementById('itemCount');
    target.innerHTML = c === 0
      ? 'No items selected yet'
      : `<strong>${c} item${c > 1 ? 's' : ''}</strong> selected`;
    document.getElementById('itemOtherWrap').style.display =
      state.selectedItems.has('Other') ? 'block' : 'none';
  });
});

// ============ FLEXIBLE CHECKBOX ============
const flex = document.getElementById('flexCheckbox');
flex.addEventListener('click', e => {
  if (e.target.tagName === 'INPUT') return;
  const cb = document.getElementById('flexible');
  cb.checked = !cb.checked;
  flex.classList.toggle('checked', cb.checked);
  if (cb.checked) document.getElementById('deadline').value = '';
});
document.getElementById('flexible').addEventListener('change', e => {
  flex.classList.toggle('checked', e.target.checked);
});
document.getElementById('deadline').addEventListener('input', e => {
  if (e.target.value) {
    document.getElementById('flexible').checked = false;
    flex.classList.remove('checked');
  }
});

// ============ FILE UPLOADS ============
function setupUpload(zoneId, inputId, listId) {
  const zone = document.getElementById(zoneId);
  const input = document.getElementById(inputId);
  const list = document.getElementById(listId);
  zone.addEventListener('dragover', e => { e.preventDefault(); zone.classList.add('dragover'); });
  zone.addEventListener('dragleave', () => zone.classList.remove('dragover'));
  zone.addEventListener('drop', e => {
    e.preventDefault(); zone.classList.remove('dragover');
    const dt = new DataTransfer();
    [...input.files].forEach(f => dt.items.add(f));
    [...e.dataTransfer.files].forEach(f => dt.items.add(f));
    input.files = dt.files;
    renderFiles(input, list);
  });
  input.addEventListener('change', () => renderFiles(input, list));
}
function renderFiles(input, list) {
  list.innerHTML = '';
  [...input.files].forEach((f, i) => {
    const ext = f.name.split('.').pop().toUpperCase().slice(0, 4);
    const sizeKB = (f.size / 1024).toFixed(0);
    const sizeStr = sizeKB > 1024 ? (sizeKB / 1024).toFixed(1) + ' MB' : sizeKB + ' KB';
    const row = document.createElement('div');
    row.className = 'upload-file';
    row.innerHTML = `
      <span class="upload-file-icon">${ext}</span>
      <span class="upload-file-name">${esc(f.name)}</span>
      <span class="upload-file-size">${sizeStr}</span>
      <button type="button" class="upload-file-remove" data-i="${i}">×</button>
    `;
    row.querySelector('.upload-file-remove').addEventListener('click', () => {
      const dt = new DataTransfer();
      [...input.files].forEach((file, idx) => { if (idx !== i) dt.items.add(file); });
      input.files = dt.files;
      renderFiles(input, list);
    });
    list.appendChild(row);
  });
}
setupUpload('logoUpload', 'logoFiles', 'logoList');
setupUpload('inspoUpload', 'inspoFiles', 'inspoList');

// ============ FORM SUBMIT ============
// Build a formatted plain-text body of the entire form.
function buildEmailBody(driveFolderUrl) {
  const teamName = document.getElementById('teamName').value.trim();
  const sports = [...state.selectedSports];
  const sportOther = document.getElementById('sportOtherText').value.trim();
  const orderType = document.querySelector('input[name="orderType"]:checked')?.value;
  const items = [...state.selectedItems];
  const itemOther = document.getElementById('itemOtherText').value.trim();
  const qty = document.querySelector('input[name="qty"]:checked')?.value;
  const date = document.getElementById('deadline').value;
  const flexible = document.getElementById('flexible').checked;
  const vision = document.getElementById('vision').value.trim();
  const firstName = document.getElementById('firstName').value.trim();
  const lastName = document.getElementById('lastName').value.trim();
  const email = document.getElementById('email').value.trim();
  const phone = document.getElementById('phone').value.trim();
  const city = document.getElementById('city').value.trim();
  const contactPref = document.querySelector('input[name="contactPref"]:checked')?.value;
  const logoFiles = [...document.getElementById('logoFiles').files].map(f => f.name);
  const inspoFiles = [...document.getElementById('inspoFiles').files].map(f => f.name);

  const orderTypeLabel = { new: 'Brand new design', reorder: 'Reorder of existing TKO design', unsure: 'Not sure yet' }[orderType] || '';
  const contactPrefLabel = { email: 'Email', phone: 'Phone', fb: 'Facebook DM', ig: 'Instagram DM' }[contactPref] || '';
  const sportLabel = sports.includes('Other') && sportOther ? sports.filter(s => s !== 'Other').concat(`Other (${sportOther})`).join(', ') : sports.join(', ');
  const itemLabel = items.includes('Other') && itemOther ? items.filter(i => i !== 'Other').concat(`Other (${itemOther})`).join(', ') : items.join(', ');
  const dateLabel = flexible ? 'Flexible' : (date ? new Date(date).toLocaleDateString('en-CA', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) : '(not specified)');

  const lines = [
    '=== NEW DESIGN REQUEST ===',
    '',
    '── TEAM ──',
    `Team / Association: ${teamName}`,
    `Sport: ${sportLabel}`,
    `Order type: ${orderTypeLabel}`,
    '',
    '── ORDER ──',
    `Items: ${itemLabel}`,
    `Approximate quantity: ${qty}`,
    `Needed by: ${dateLabel}`,
    '',
    '── DESIGN VISION ──',
    vision,
    '',
    '── CONTACT ──',
    `Name: ${firstName} ${lastName}`,
    `Email: ${email}`,
    `Phone: ${phone}`,
    `Location: ${city}`,
    `Preferred contact: ${contactPrefLabel}`,
    '',
    '── FILES ──',
  ];

  if (driveFolderUrl) {
    lines.push(`Uploaded files: ${driveFolderUrl}`);
  }
  if (logoFiles.length) {
    lines.push(`Logos (${logoFiles.length}): ${logoFiles.join(', ')}`);
  }
  if (inspoFiles.length) {
    lines.push(`Inspiration (${inspoFiles.length}): ${inspoFiles.join(', ')}`);
  }
  if (!driveFolderUrl && !logoFiles.length && !inspoFiles.length) {
    lines.push('(none uploaded)');
  } else if (!driveFolderUrl && (logoFiles.length || inspoFiles.length)) {
    lines.push('');
    lines.push('⚠️  Files were attached on the form but the Drive uploader is not configured.');
    lines.push('Reach out to the customer to collect them by email.');
  }

  return lines.join('\n');
}

// Upload files to the Apps Script Web App, which drops them into a new folder in Drive
// and returns the folder URL.
async function uploadFilesToDrive(teamName, firstName, lastName) {
  if (!CONFIG.driveUploadUrl) return null;

  const logoInput = document.getElementById('logoFiles');
  const inspoInput = document.getElementById('inspoFiles');
  const allFiles = [...logoInput.files, ...inspoInput.files];
  if (!allFiles.length) return null;

  // Validate file sizes up front
  for (const f of allFiles) {
    if (f.size > CONFIG.maxFileSizeMB * 1024 * 1024) {
      throw new Error(`File "${f.name}" exceeds the ${CONFIG.maxFileSizeMB}MB upload limit. Please email it to info@tkojerseyco.com after submitting.`);
    }
  }

  // Convert files to base64 (Apps Script Web Apps don't accept binary multipart from CORS-blocked requests).
  const fileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]); // strip the data: prefix
    reader.onerror = () => reject(new Error(`Failed to read ${file.name}`));
    reader.readAsDataURL(file);
  });

  const logoFiles = await Promise.all([...logoInput.files].map(async f => ({
    name: f.name,
    type: f.type || 'application/octet-stream',
    category: 'logo',
    data: await fileToBase64(f),
  })));
  const inspoFiles = await Promise.all([...inspoInput.files].map(async f => ({
    name: f.name,
    type: f.type || 'application/octet-stream',
    category: 'inspiration',
    data: await fileToBase64(f),
  })));

  const payload = {
    teamName,
    firstName,
    lastName,
    submittedAt: new Date().toISOString(),
    files: [...logoFiles, ...inspoFiles],
  };

  // Apps Script Web Apps require text/plain to avoid CORS preflight.
  const res = await fetch(CONFIG.driveUploadUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`Drive upload failed (${res.status}). Files will be listed in the email instead.`);
  }
  const json = await res.json();
  if (!json.folderUrl) {
    throw new Error('Drive upload returned no folder URL.');
  }
  return json.folderUrl;
}

// Post the formatted lead to Shopify's contact form. This lands in the email
// configured under Shopify Admin → Settings → Notifications.
// Submit through the hidden real Shopify {% form 'contact' %} on the page.
// Going through the actual rendered form is required because Shopify injects an
// invisible Cloudflare Turnstile / CAPTCHA token into it; raw fetch('/contact')
// gets a 400 "Missing CAPTCHA token". The form targets a hidden iframe so the
// user stays on this page (success screen takes over).
async function submitToShopify(emailBody, firstName, lastName, email, phone, teamName) {
  const form = document.getElementById('tkoShopifyContactForm');
  const iframe = document.querySelector('iframe[name="tkoShopifyTarget"]');
  if (!form || !iframe) {
    throw new Error('Shopify contact form not found on page. Re-push the template.');
  }

  // Fill the hidden form's inputs.
  const setVal = (selector, val) => {
    const el = form.querySelector(selector);
    if (el) el.value = val == null ? '' : String(val);
  };
  setVal('[name="contact[name]"]',    `${firstName} ${lastName}`);
  setVal('[name="contact[email]"]',   email);
  setVal('[name="contact[phone]"]',   phone);
  setVal('[name="contact[subject]"]', `New Design Request: ${teamName}`);
  setVal('[name="contact[body]"]',    emailBody);

  // Wait for the iframe to load after submit. Shopify will either redirect
  // to a success URL or re-render the form with errors — either way the iframe
  // fires a load event. We can't read the iframe contents (cross-origin via
  // checkout subdomain on some Shopify setups), so we treat any load as success.
  // 30-second timeout in case Turnstile blocks the request entirely.
  return new Promise((resolve, reject) => {
    let done = false;
    const cleanup = () => {
      iframe.removeEventListener('load', onLoad);
      clearTimeout(timer);
    };
    const onLoad = () => {
      if (done) return;
      done = true;
      cleanup();
      resolve(true);
    };
    iframe.addEventListener('load', onLoad);
    const timer = setTimeout(() => {
      if (done) return;
      done = true;
      cleanup();
      reject(new Error('Shopify submission timed out after 30s. Bot protection may have blocked it — please email info@tkojerseyco.com.'));
    }, 30000);

    try {
      form.submit();
    } catch (err) {
      cleanup();
      reject(err);
    }
  });
}

// Set the submit button into a loading state.
function setSubmitting(btn, isSubmitting) {
  if (isSubmitting) {
    btn.dataset.originalText = btn.innerHTML;
    btn.innerHTML = 'Sending… ⏳';
    btn.disabled = true;
  } else {
    btn.innerHTML = btn.dataset.originalText || 'Send My Design Request →';
    btn.disabled = false;
  }
}

document.getElementById('designForm').addEventListener('submit', async e => {
  e.preventDefault();
  const submitBtn = e.target.querySelector('button[type="submit"]');

  // Validate step 4 fields
  const required = ['firstName', 'lastName', 'email', 'phone', 'city'];
  const missing = required.filter(id => !document.getElementById(id).value.trim());
  const contactPref = document.querySelector('input[name="contactPref"]:checked');
  if (missing.length || !contactPref) { flashIncomplete(); return; }

  // Pull values once
  const teamName = document.getElementById('teamName').value.trim();
  const firstName = document.getElementById('firstName').value.trim();
  const lastName = document.getElementById('lastName').value.trim();
  const email = document.getElementById('email').value.trim();
  const phone = document.getElementById('phone').value.trim();

  setSubmitting(submitBtn, true);

  let driveFolderUrl = null;
  let driveError = null;

  // Step 1: Upload files to Drive (best-effort — never blocks the lead from being captured).
  try {
    driveFolderUrl = await uploadFilesToDrive(teamName, firstName, lastName);
  } catch (err) {
    console.warn('Drive upload error:', err);
    driveError = err.message || 'Files could not be uploaded.';
  }

  // Step 2: Always submit the lead to Shopify, even if file upload failed.
  try {
    const emailBody = buildEmailBody(driveFolderUrl);
    await submitToShopify(emailBody, firstName, lastName, email, phone, teamName);
  } catch (err) {
    console.error('Shopify submission error:', err);
    setSubmitting(submitBtn, false);
    alert('Something went wrong sending your request.\n\n' + (err && err.message ? err.message : '') + '\n\nOr email us directly at info@tkojerseyco.com.');
    return;
  }

  // Generate a reference for the customer
  const ref = 'TKO-' + Math.random().toString(36).substr(2, 5).toUpperCase() + '-' + new Date().getFullYear();
  document.getElementById('refNum').innerHTML = `<strong>${ref}</strong>`;

  // If Drive failed but Shopify went through, still show success but warn the customer
  if (driveError) {
    const refEl = document.getElementById('refNum');
    refEl.innerHTML += `<div style="margin-top:14px;font-size:13px;color:var(--error);font-weight:600;">⚠ A note about your files: ${esc(driveError)} We'll email you to collect them directly.</div>`;
  }

  // Clear autosave so a returning visitor sees a fresh form
  try { localStorage.removeItem(FORM_KEY); } catch (e) {}

  document.getElementById('formShell').style.display = 'none';
  document.getElementById('nextBand').style.display = 'none';
  document.getElementById('successScreen').classList.add('shown');
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

// ============ PROGRESS RAIL CLICK ============
document.querySelectorAll('.progress-step').forEach(s => {
  s.addEventListener('click', () => {
    const n = parseInt(s.dataset.go);
    if (n) toggleStep(n);
  });
});

// ============ AUTOSAVE TO LOCALSTORAGE ============
const FORM_KEY = 'tko-design-form-v1';
function autosave() {
  try {
    const data = {
      teamName: document.getElementById('teamName').value,
      sports: [...state.selectedSports],
      sportOther: document.getElementById('sportOtherText').value,
      orderType: document.querySelector('input[name="orderType"]:checked')?.value,
      items: [...state.selectedItems],
      itemOther: document.getElementById('itemOtherText').value,
      qty: document.querySelector('input[name="qty"]:checked')?.value,
      deadline: document.getElementById('deadline').value,
      flexible: document.getElementById('flexible').checked,
      vision: document.getElementById('vision').value,
      firstName: document.getElementById('firstName').value,
      lastName: document.getElementById('lastName').value,
      email: document.getElementById('email').value,
      phone: document.getElementById('phone').value,
      city: document.getElementById('city').value,
      contactPref: document.querySelector('input[name="contactPref"]:checked')?.value,
    };
    localStorage.setItem(FORM_KEY, JSON.stringify(data));
  } catch(e) {}
}
function autoload() {
  try {
    const raw = localStorage.getItem(FORM_KEY);
    if (!raw) return;
    const d = JSON.parse(raw);
    if (d.teamName) document.getElementById('teamName').value = d.teamName;
    if (d.sports) d.sports.forEach(s => {
      const card = document.querySelector(`.sport-card[data-sport="${s}"]`);
      if (card) { card.classList.add('selected'); state.selectedSports.add(s); }
    });
    if (d.sportOther) document.getElementById('sportOtherText').value = d.sportOther;
    if (d.sports?.includes('Other')) document.getElementById('sportOtherWrap').style.display = 'block';
    if (d.orderType) {
      const r = document.querySelector(`input[name="orderType"][value="${d.orderType}"]`);
      if (r) r.checked = true;
    }
    if (d.items) d.items.forEach(i => {
      const card = document.querySelector(`.item-card[data-item="${i}"]`);
      if (card) { card.classList.add('selected'); state.selectedItems.add(i); }
    });
    if (d.items?.length) {
      document.getElementById('itemCount').innerHTML = `<strong>${d.items.length} item${d.items.length>1?'s':''}</strong> selected`;
    }
    if (d.itemOther) document.getElementById('itemOtherText').value = d.itemOther;
    if (d.items?.includes('Other')) document.getElementById('itemOtherWrap').style.display = 'block';
    if (d.qty) {
      const r = document.querySelector(`input[name="qty"][value="${d.qty}"]`);
      if (r) r.checked = true;
    }
    if (d.deadline) document.getElementById('deadline').value = d.deadline;
    if (d.flexible) {
      document.getElementById('flexible').checked = true;
      document.getElementById('flexCheckbox').classList.add('checked');
    }
    if (d.vision) document.getElementById('vision').value = d.vision;
    ['firstName','lastName','email','phone','city'].forEach(k => {
      if (d[k]) document.getElementById(k).value = d[k];
    });
    if (d.contactPref) {
      const r = document.querySelector(`input[name="contactPref"][value="${d.contactPref}"]`);
      if (r) r.checked = true;
    }
  } catch(e) {}
}
document.addEventListener('input', autosave);
document.addEventListener('change', autosave);
document.addEventListener('click', e => {
  if (e.target.closest('.sport-card') || e.target.closest('.item-card')) {
    setTimeout(autosave, 50);
  }
});
autoload();
